import { getSessionEpoch } from '../auth/session';

const own = new Map<string, number>();
let epoch = '';
function prune() {
    if (epoch !== getSessionEpoch()) { own.clear(); epoch = getSessionEpoch(); }
    const now = Date.now();
    own.forEach((expires, id) => { if (expires <= now) own.delete(id); });
}
export function registerTaskOperation() {
    prune();
    const id = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    own.set(id, Date.now() + 10 * 60 * 1000);
    if (own.size > 500) own.delete(own.keys().next().value as string);
    return id;
}
export function isOwnTaskOperation(id?: string) { prune(); return !!id && own.has(id); }
